<button #trigger class="select-button" (click)="toggleDropdown()">
  <div class="select-button-icon">
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 16.9984C13.1037 16.9984 13.9985 17.8939 13.9985 18.9984C13.9985 20.103 13.1037 20.9984 12 20.9984C10.8963 20.9984 10.0016 20.103 10.0016 18.9984C10.0016 17.8939 10.8963 16.9984 12 16.9984ZM13.9985 11.9984C13.9985 10.8939 13.1037 9.99844 12 9.99844C10.8963 9.99844 10.0016 10.8939 10.0016 11.9984C10.0016 13.103 10.8963 13.9984 12 13.9984C13.1037 13.9984 13.9985 13.103 13.9985 11.9984ZM13.9985 4.99844C13.9985 3.89387 13.1037 2.99844 12 2.99844C10.8963 2.99844 10.0016 3.89387 10.0016 4.99844C10.0016 6.10301 10.8963 6.99844 12 6.99844C13.1037 6.99844 13.9985 6.10301 13.9985 4.99844Z"
        fill="#2C3A4A"
      />
    </svg>
  </div>
</button>
<div class="select" [class.active]="isActive">
  <div #menuContainer class="select-dropdown" [ngClass]="positionClass">
    <ul>
      <li
        *ngFor="let option of options; let i = index"
        (click)="onChange(option)"
      >
        <input
          id="{{ id + '_' + i }}"
          type="radio"
          value="{{ option.value }}"
          (click)="onChange($event)"
        />
        <label [for]="id">{{ option.label | translate }}</label>
      </li>
    </ul>
  </div>
</div>
